<template>
  <v-list>
    <div v-for="(option, index) in options" :key="index">
      <v-divider v-if="option.divider"></v-divider>
      <div v-else>
        <v-list-tile v-if="typeof option.subOptions === 'undefined'" :style="{ color: option.colour }">
          <v-list-tile-content>
            <v-list-tile-title v-on:click="option.click">{{option.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-group v-else>
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{option.title}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-for="(subOption, subIndex) in option.subOptions" :key="subIndex">
            <v-list-tile-content>
              <v-list-tile-title v-on:click="subOption.click">{{subOption.title}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </div>
    </div>
  </v-list>
</template>

<script>

import { objectTypes, red500 } from '@/utils/constants'
import { getTreeDataForNode } from '@/graph_parts/tree_data'
import { addNewNodeAndStartEdit, createGroup, calculatePosition, toggleIsIncludedInQuery, sortAZ } from '@/graph_parts/tds_diagram'

export default {
  name: 'ContextMenu',
  props: ['isTester', 'clickedObject', 'bus', 'layoutInline'],
  methods: {
    cutSelection (event) {
      this.clickedObject.diagram.commandHandler.cutSelection()
      this.clickedObject.diagram.currentTool.stopTool()
    },
    copySelection (event) {
      this.clickedObject.diagram.commandHandler.copySelection()
      this.clickedObject.diagram.currentTool.stopTool()
    },
    deleteSelection (event) {
      this.clickedObject.diagram.commandHandler.deleteSelection()
      this.clickedObject.diagram.currentTool.stopTool()
    },
    cxCommand (event, val) {
      if (val === undefined) val = event.currentTarget.id
      var diagram = this.clickedObject ? this.clickedObject.diagram : null
      switch (val) {
        case 'cut': diagram.commandHandler.cutSelection(); break
        case 'copy': diagram.commandHandler.copySelection(); break
        case 'paste': diagram.commandHandler.pasteSelection(diagram.lastInput.documentPoint); break
        case 'delete': diagram.commandHandler.deleteSelection(); break
      }
      diagram.currentTool.stopTool()
    },
    toggleIsNegative (event) {
      const diagram = this.clickedObject.diagram
      diagram.startTransaction()
      diagram.selection.each(function (node) {
        diagram.model.setDataProperty(node.data, 'isNegative', !node.data.isNegative)
      })
      diagram.commitTransaction()
      this.clickedObject.diagram.currentTool.stopTool()
    },
    toggleFieldSpecifier (event) {
      const diagram = this.clickedObject.diagram
      const data = this.clickedObject.data
      diagram.startTransaction('toggleFieldSpecifier')
      if (typeof data.fieldSpecifier === 'undefined' || data.fieldSpecifier.trim() === '') {
        diagram.model.setDataProperty(data, 'fieldSpecifier', '')
        const node = diagram.findNodeForData(data)
        const textBlock = node.data.isGroup
          ? node.elt(0).elt(1).elt(0).elt(0).elt(0).elt(0).elt(1)
          : node.elt(0).elt(1).elt(0).elt(1)
        diagram.toolManager.textEditingTool.selectsTextOnActivate = false
        diagram.commandHandler.editTextBlock(textBlock)
      } else {
        diagram.model.setDataProperty(data, 'fieldSpecifier', '')
        diagram.selection.each(function (node) {
          diagram.model.setDataProperty(node.data, 'fieldSpecifier', '')
        })
        this.clickedObject.diagram.currentTool.stopTool()
      }
      diagram.commitTransaction('toggleFieldSpecifier')
    },
    toggleIsIncludedInQuery (event) {
      const diagram = this.clickedObject.diagram
      const newValue = !this.clickedObject.data.isIncludedInQuery
      const parts = diagram.selection.toArray()
      toggleIsIncludedInQuery(parts, diagram, newValue)
      if (newValue === false) {
        parts.forEach(p => {
          diagram.model.setDataProperty(p.data, '_count', null)
          diagram.model.setDataProperty(p.data, '_showingCount', null)
        })
      }
      this.clickedObject.diagram.currentTool.stopTool()
    },
    openSearchResults (event) {
      const diagram = this.clickedObject.diagram
      const node = diagram.findNodeForData(this.clickedObject.data)
      this.bus.$emit('subqueryRequested', getTreeDataForNode(node))
      this.clickedObject.diagram.currentTool.stopTool()
    },
    showSelectedTerms (event) {
      event.preventDefault()
      event.stopPropagation()
      const data = this.clickedObject.data
      this.bus.$emit('suggestTerms', data.text, data.key, data.group)
      this.clickedObject.diagram.currentTool.stopTool()
    },
    toggleExpandClose (event) {
      const diagram = this.clickedObject.diagram
      diagram.selection.each(function (node) {
        diagram.model.setDataProperty(node.data, 'isSubGraphExpanded', !node.data.isSubGraphExpanded)
      })
      this.clickedObject.diagram.currentTool.stopTool()
    },
    handleLayoutSquareClick (event) {
      const diagram = this.clickedObject.diagram
      diagram.selection.each(function (node) {
        diagram.model.setDataProperty(node.data, 'layout', 'square')
      })
      diagram.layout.invalidateLayout()
      this.clickedObject.diagram.currentTool.stopTool()
    },
    handleLayoutHorizontalClick (event) {
      const diagram = this.clickedObject.diagram
      diagram.selection.each(function (node) {
        diagram.model.setDataProperty(node.data, 'layout', 'horizontal')
      })
      diagram.layout.invalidateLayout()
      this.clickedObject.diagram.currentTool.stopTool()
    },
    handleLayoutVerticalClick (event) {
      const diagram = this.clickedObject.diagram
      diagram.selection.each(function (node) {
        diagram.model.setDataProperty(node.data, 'layout', 'vertical')
      })
      diagram.layout.invalidateLayout()
      this.clickedObject.diagram.currentTool.stopTool()
    },
    handleCreateTermClick (event) {
      addNewNodeAndStartEdit(
        this.clickedObject.diagram,
        undefined,
        this.clickedObject.data ? this.clickedObject.data.key : undefined
      )
    },
    handleCreateGroupClick (event) {
      createGroup(
        this.clickedObject.diagram,
        this.clickedObject.data ? this.clickedObject.data.key : undefined
      )
      this.clickedObject.diagram.currentTool.stopTool()
    },
    handlePasteClick (event) {
      const diagram = this.clickedObject.diagram
      diagram.commandHandler.pasteSelection(calculatePosition(diagram))
      this.clickedObject.diagram.currentTool.stopTool()
    },
    handleSortAZ (event) {
      const diagram = this.clickedObject.diagram
      const parts = diagram.selection.toArray()
      sortAZ(parts, diagram)
      this.clickedObject.diagram.currentTool.stopTool()
    },
    canvasContextMenuOptions () {
      return [
        {
          title: 'Create term',
          click: this.handleCreateTermClick
        },
        {
          title: 'Create group',
          click: this.handleCreateGroupClick
        },
        {
          divider: true
        },
        {
          title: 'Paste',
          click: this.handlePasteClick
        }
      ]
    },
    nodeContextMenuOptions (data) {
      const r = []
      if (data.isIncludedInQuery) {
        r.push(
          {
            title: 'Cut',
            click: this.cutSelection
          },
          {
            title: 'Copy',
            click: this.copySelection
          },
          {
            title: 'Delete',
            colour: red500,
            click: this.deleteSelection
          },
          {
            divider: true
          },
          {
            title: `${data.isNegative ? 'Remove' : 'Apply'} NOT`,
            click: this.toggleIsNegative
          },
          {
            title: `${(data.fieldSpecifier && data.fieldSpecifier.trim() !== '') ? 'Remove' : 'Add'} field tag`,
            click: this.toggleFieldSpecifier
          },
          {
            divider: true
          },
          {
            title: 'Execute',
            click: this.openSearchResults
          }
        )
      }
      r.push(
        {
          title: data.isIncludedInQuery ? 'Disable' : 'Enable',
          click: this.toggleIsIncludedInQuery
        }
      )
      if (data.isIncludedInQuery) {
        r.push(
          {
            divider: true
          },
          {
            title: 'Generate keywords',
            click: this.showSelectedTerms
          }
        )
      }
      return r
    },
    groupContextMenuOptions (group) {
      const r = []
      const data = group.data
      const groupPart = group.diagram.findPartForData(data)
      if (data.isIncludedInQuery) {
        if (!this.layoutInline) {
          r.push(
            {
              title: 'Layout',
              subOptions: [
                {
                  title: `${data.layout === 'square' ? '✓ ' : ''} Square`,
                  click: this.handleLayoutSquareClick
                },
                {
                  title: `${data.layout === 'horizontal' ? '✓ ' : ''} Horizontal`,
                  click: this.handleLayoutHorizontalClick
                },
                {
                  title: `${data.layout === 'vertical' ? '✓ ' : ''} Vertical`,
                  click: this.handleLayoutVerticalClick
                }
              ]
            },
            {
              divider: true
            }
          )
        }
        r.push(
          {
            title: 'Create',
            subOptions: [
              {
                title: 'Term',
                click: this.handleCreateTermClick
              },
              {
                title: 'Group',
                click: this.handleCreateGroupClick
              }
            ]
          },
          {
            divider: true
          }
        )
        r.push(
          {
            title: 'Cut',
            click: this.cutSelection
          },
          {
            title: 'Copy',
            click: this.copySelection
          },
          {
            title: 'Delete',
            colour: red500,
            click: this.deleteSelection
          },
          {
            divider: true
          }
        )
        r.push(
          {
            title: `${data.isNegative ? 'Remove' : 'Apply'} NOT`,
            click: this.toggleIsNegative
          },
          {
            divider: true
          }
        )
        if (groupPart.memberParts && groupPart.memberParts.count > 0) {
          r.push(
            {
              title: 'Execute',
              click: this.openSearchResults
            },
            {
              divider: true
            }
          )
        }
      }
      r.push(
        {
          title: data.isIncludedInQuery ? 'Disable' : 'Enable',
          click: this.toggleIsIncludedInQuery
        },
        {
          title: `${(data.fieldSpecifier && data.fieldSpecifier.trim() !== '') ? 'Remove' : 'Add'} field tag`,
          click: this.toggleFieldSpecifier
        },
        {
          divider: true
        }
      )
      if (groupPart.memberParts && groupPart.memberParts.count > 0) {
        r.push(
          {
            divider: true
          },
          {
            title: 'Sort A-Z',
            click: this.handleSortAZ
          }
        )
      }
      return r
    }
  },
  computed: {
    isCanvasClicked: function () {
      return this.clickedObject !== null && this.clickedObject.type === objectTypes.canvas
    },
    isNodeClicked: function () {
      return this.clickedObject !== null && this.clickedObject.type === objectTypes.node
    },
    isGroupClicked: function () {
      return this.clickedObject !== null && this.clickedObject.type === objectTypes.group
    },
    isIncludedInQuery: function () {
      return this.clickedObject !== null && this.clickedObject.data && this.clickedObject.data.isIncludedInQuery
    },
    options: function () {
      let r = null
      if (this.clickedObject !== null) {
        if (this.clickedObject.type === objectTypes.node) {
          r = this.nodeContextMenuOptions(this.clickedObject.data)
        } else if (this.clickedObject.type === objectTypes.group) {
          r = this.groupContextMenuOptions(this.clickedObject)
        }
      }
      if (r === null) {
        r = this.canvasContextMenuOptions()
      }
      return r
    }
  }
}
</script>

<!-- Setting scoped here seems to stop #myDiagramDiv > textarea being picked up on display i.e. when editing name -->
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/parts/ContextMenu.vue